import React from 'react'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as Actions from '../../actions/Search';
import * as SG from '../../constants/AppSettings'
import * as RT from '../../constants/Routing'


class Component extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      afterSearch: false
    }
  };

  closeModal = () => {
    const searchModal = document.getElementById('searchModal')
    document.body.classList.toggle('overflow-hidden')
    document.documentElement.classList.toggle('overflow-hidden')
    if (searchModal.classList.contains("slideIn")) {
      searchModal.classList.remove('slideIn')
      const toggleBtn = document.querySelector('.searchToggleBtn')
      toggleBtn.classList.remove('active')

      if (toggleBtn.innerText === 'search') {
        toggleBtn.innerText = 'close'
      } else {
        toggleBtn.innerText = 'search'
      }
    }
  }

  componentWillReceiveProps = (nextProps) => {
    // console.log('afterSearch', nextProps.Search, this.props.Search)
    const oldResult = this.props.Search.searchCommunity
    const newResult = nextProps.Search.searchCommunity
    const { history } = this.props
    // console.log('afterSearchHistory', this.props, nextProps)
    if (newResult !== null && this.props.location.pathname !== RT.SEARCH_RESULT_PATH) {
      history.push(RT.SEARCH_RESULT_PATH)
    }
  }

  getCheckedVal = name => {
    const elements = document.getElementsByName(name);
    let values = []
    for (var i = 0; i < elements.length; i++) {
      if (elements[i].checked === true) {
        values.push(elements[i].value)
      }
    }
    return values
  }

  onSubmit = (e) => {
    
    e.preventDefault();
    let params = {}
    params.categories = this.getCheckedVal('category[]')
    params.areas = this.getCheckedVal('place[]')

    const splitReg = (/,|、|\s|　/g)
    const keywords = document.getElementById('keywords').value.split(splitReg)
    let newKeywords = []
    for (var i = 0; i < keywords.length; ++i) {
      if(keywords[i] !== "") newKeywords.push(keywords[i])
    }
    params.keywords = newKeywords
    this.props.searchCommunity(params)
  }

  render = () => {
    // console.log('モーダル', this.props, this.state)
    const cats = SG.categories.map((cat) => {
      return (
        <div className='checkbox-wrap' key={cat.id} >
          <input id={`cat_${cat.id}`} type='checkbox' value={cat.name} name="category[]" />
          <label htmlFor={`cat_${cat.id}`} >{cat.name}</label>
        </div>
        
      )
    })

    const areas = SG.places.map((place) => {
      return (
        <div className='checkbox-wrap' key={place.id} >
          <input id={`area_${place.id}`} type="checkbox" value={place.name} name="place[]" />
          <label htmlFor={`area_${place.id}`} >{place.name}</label>
        </div>
      )
    })

    return (
      <div id='searchModal' className='searchWrap panel'>
        <div className='container'>
          <h2 className='headline'>
            サークルを検索
          </h2>
          <form className='form text-left' onSubmit={this.onSubmit}>
            <div className='field'>
              <h3 className='formHeadline'><i className="material-icons">translate</i>キーワード</h3>
              <input type="text" name="keywords[]" id='keywords' />
            </div>
            <div className='field'>
              <h3 className='formHeadline'><i className="material-icons">category</i>カテゴリー</h3>
              {cats}
            </div>
            <div className='field'>
              <h3 className='formHeadline'><i className="material-icons">location_on</i>エリア</h3>
              {areas}
            </div>
            <input type='submit' className='btn btn-submit' value='検索する' />
            <span className='btn btn-white mt-1 btn-block' onClick={this.closeModal}>閉じる</span>
          </form>
        </div>
      </div>
    )
  }
}


const mapStateToProps = (state) => {
  return state
};

const mapDispatchToProps = (dispatch) => (bindActionCreators(Actions, dispatch));


const Container = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Component);

export default withRouter(Container);




// WEBPACK FOOTER //
// ./src/components/Search/SearchModal.jsx